export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <rect width="13.435" height="13.435" x="12" y="2.563" fill="currentcolor" rx="2" transform="rotate(45 12 2.563)"/>
</svg>
`;
